import { render, staticRenderFns } from "./modal-tournament-win.vue?vue&type=template&id=b934a27c"
import script from "./modal-tournament-win.vue?vue&type=script&lang=js"
export * from "./modal-tournament-win.vue?vue&type=script&lang=js"
import style0 from "./modal-tournament-win.vue?vue&type=style&index=0&id=b934a27c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports